import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import pdficon from "../assets/pdficon.png";
import DoneGreen from "../assets/doneGreen.svg";
import {
  mondayDayYearFormat,
  formatPhone,
  handleError,
} from "../CommonJquery/CommonJquery.js";
import {
  update_booking_car_in_review,
  server_post_data,
  upload_image_to_folder,
  multicar_upload_image,
  save_user_data_for_booking,
  upload_mvr_image,
} from "../ServiceConnection/serviceconnection.js";
import { toBeRequired } from "@testing-library/jest-dom/matchers.js";
import { UploadIcon, XIcon } from "lucide-react";

const ReviewModal = ({
  modalShow,
  handleClose,
  avaliblecar,
  SelectedData,
  APL_LINK,
  activeAgree,
  setActiveAgree,
  handleuploadMvrFile,
  handleuploadDLFile,
  handleuploadDLFileMVR,
  toggleActiveAgree,
  handleActiveDeactive,
  triggerDownloadPDF,
  triggerDownloadMVR,
  triggerDownloadDL,
  setUploadedDamageImagesfinal,
  DringImg,
}) => {
  console.log("SelectedData", SelectedData);

  // State to track MVR edit mode
  const [isMvrEditMode, setIsMvrEditMode] = useState(false);
  const [isDlEditMode, setIsDlEditMode] = useState(false);
  const [isCarChnageMode, setIsCarChnageMode] = useState(false);
  const [isNameEditMode, setIsNameEditMode] = useState(false);
  const [uploadedDamageImages, setUploadedDamageImages] = useState([]);
  const [damnageImgPath, setdamnageImgPath] = useState("");
  const [DamageImg, setDamageImg] = useState([]);

  // Name edit states
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [updatedName, setUpdatedName] = useState("");
  const [nameUpdateSuccess, setNameUpdateSuccess] = useState(false);

  function cleanInput(inputStr) {
    if (typeof inputStr !== "string") return "";

    let parts = inputStr.split("~@~");

    // Get items before and after ~@~
    let before = parts[0] || "";
    let after = parts[1] || "";

    // Split both by commas, remove "Other" and trim spaces
    let items = [...before.split(","), ...after.split(",")]
      .map((item) => item.trim())
      .filter((item) => item && item.toLowerCase() !== "other");

    // Return cleaned result
    return items.join(", ");
  }

  const handleRemoveImage = (index) => {
    const updatedImages = uploadedDamageImages.filter((_, i) => i !== index);
    setUploadedDamageImages(updatedImages);
    setUploadedDamageImagesfinal(updatedImages);
  };

  useEffect(() => {
    if (SelectedData && SelectedData.primary_id) {
      master_data_get();
      // Initialize name fields
      if (SelectedData.name) {
        const nameParts = SelectedData.name.trim().split(" ");
        setFirstName(nameParts[0] || "");
        setLastName(nameParts.slice(1).join(" ") || "");
      }
    }
  }, [SelectedData]);

  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("booking_id", SelectedData.primary_id);
    fd.append("image_status", 10);
    await server_post_data(multicar_upload_image, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setdamnageImgPath(Response.data.message.image_link_liCENCE);
          setDamageImg(Response.data.message.damage_image);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [newCar, setnewCar] = useState(null);
  const [newCarUpdate, setnewCarUpdate] = useState(false);
  const [newcarid, setnewcarid] = useState("");

  const handelsavecarnew = async () => {
    if (newcarid === "") {
      alert("select car");
      return;
    }
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", SelectedData.primary_id);
    fd.append("car_id", newcarid);
    await server_post_data(update_booking_car_in_review, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          //console.log("done");
        }
        setshowLoaderAdmin(false);
        setIsCarChnageMode(false);
        setnewCarUpdate(true);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Handler for saving name
  const handleSaveName = async () => {
    if (!firstName.trim() || !lastName.trim()) {
      alert("Please enter both first name and last name");
      return;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("user_id", SelectedData.user_id);
    fd.append("booking_id", SelectedData.primary_id);
    fd.append("first_name", firstName.trim());
    fd.append("last_name", lastName.trim());

    await server_post_data(save_user_data_for_booking, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const fullName = `${firstName.trim()} ${lastName.trim()}`;
          setUpdatedName(fullName);
          setNameUpdateSuccess(true);
          setIsNameEditMode(false);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Handler for canceling name edit
  const handleCancelNameEdit = () => {
    // Reset to original values
    if (SelectedData.name) {
      const nameParts = SelectedData.name.trim().split(" ");
      setFirstName(nameParts[0] || "");
      setLastName(nameParts.slice(1).join(" ") || "");
    }
    setIsNameEditMode(false);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + uploadedDamageImages.length > 3) {
      alert("You can only upload a maximum of 3 images.");
      return;
    }

    const remainingSlots = 3 - uploadedDamageImages.length;
    const filesToUpload = files.slice(0, remainingSlots);

    filesToUpload.forEach((file, index) => {
      uploadImageserver(file, index);
    });
  };

  const uploadImageserver = async (file, index) => {
    const fd = new FormData();
    fd.append("image", file);
    fd.append("image_tag", "mvr_image");

    try {
      const response = await server_post_data(upload_image_to_folder, fd);
      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const uploadedImageName = response.data.message.image_uploaded;
        setUploadedDamageImages((prev) => [...prev, uploadedImageName]);
        setUploadedDamageImagesfinal((prev) => [...prev, uploadedImageName]);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const uploadImageserverName = async (file, index) => {
    const fd = new FormData();
    fd.append("image", file);
    fd.append("image_tag", "mvr_image");
    fd.append("call_id", "mvr_image");

    try {
      const response = await server_post_data(upload_mvr_image, fd);
      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const uploadedImageName = response.data.message.image_uploaded;
        setUploadedDamageImages((prev) => [...prev, uploadedImageName]);
        setUploadedDamageImagesfinal((prev) => [...prev, uploadedImageName]);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  return (
    <Modal
      show={modalShow}
      className="releaseModal"
      centered
      onHide={() => handleClose(0)}
      size="lg"
      scrollable
    >
      <Modal.Header className="releaseModalHeader">
        Review Application
      </Modal.Header>

      <Modal.Body className="releaseModalBody">
        <div className="releaseModalHead">
          <div className="releaseModalDetails">
            {/* Car Details Table */}
            <table className="table">
              <thead>
                <tr style={{ borderBottom: "transparent" }}>
                  <th style={{ paddingBottom: "0.5rem" }}>Car Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fadeColor">Name</td>
                  <td>
                    {isCarChnageMode ? (
                      <div className="d-flex gap-2 align-items-center">
                        <select
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            setnewcarid(selectedId);
                            const selectedCar = avaliblecar.find(
                              (car) => car.primary_id == selectedId,
                            );
                            console.log(selectedCar);
                            if (selectedCar) {
                              setnewCar(selectedCar);
                              setnewCarUpdate(true);
                            }
                          }}
                        >
                          <option value="">Select Car</option>
                          {avaliblecar &&
                            avaliblecar.length > 0 &&
                            avaliblecar.map((item, index) => {
                              return (
                                <option value={item.primary_id} key={index}>
                                  {item.car_name} {item.car_tagline}
                                </option>
                              );
                            })}
                        </select>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handelsavecarnew()}
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          Update
                        </button>
                      </div>
                    ) : (
                      <>
                        {newCarUpdate ? (
                          <>
                            {newCar?.car_name} ({newCar?.car_tagline}){" "}
                          </>
                        ) : (
                          <>
                            {SelectedData?.car_data?.[0]?.car_name} (
                            {SelectedData?.car_data?.[0]?.car_tagline}){" "}
                          </>
                        )}
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => setIsCarChnageMode(true)}
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          Change
                        </button>
                      </>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">Licence Plate No.</td>
                  <td>
                    {newCarUpdate
                      ? newCar?.car_no
                      : SelectedData?.car_data?.[0]?.car_no}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">VIN</td>
                  <td>
                    {newCarUpdate
                      ? newCar?.vin
                      : SelectedData?.car_data?.[0]?.vin}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Driver Details Table */}
            <table className="table">
              <thead>
                <tr style={{ borderBottom: "transparent" }}>
                  <th style={{ paddingBottom: "0.5rem" }}>Driver's Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fadeColor">Name</td>
                  <td>
                    {!isNameEditMode ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span>
                          {nameUpdateSuccess ? updatedName : SelectedData.name}
                        </span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => setIsNameEditMode(true)}
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          Edit
                        </button>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            className="form-control input_field_custom1"
                            placeholder="First Name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            style={{ flex: 1 }}
                          />
                          <input
                            type="text"
                            className="form-control input_field_custom1"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            style={{ flex: 1 }}
                          />
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={handleSaveName}
                            style={{ fontSize: "12px", padding: "2px 8px" }}
                            disabled={showLoaderAdmin}
                          >
                            {showLoaderAdmin ? "Saving..." : "Save"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={handleCancelNameEdit}
                            style={{ fontSize: "12px", padding: "2px 8px" }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">EMAIL</td>
                  <td>{SelectedData.email}</td>
                </tr>
                <tr>
                  <td className="fadeColor">MOBILE NO</td>
                  <td>
                    {SelectedData?.mobile_no &&
                      formatPhone(SelectedData?.mobile_no)}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">Current Address</td>
                  <td>
                    {SelectedData.present_map_address}, {SelectedData.city},{" "}
                    {SelectedData.pin_code}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">State</td>
                  <td>{SelectedData.state}</td>
                </tr>
                <tr>
                  <td className="fadeColor">Pickup Date</td>
                  <td>{mondayDayYearFormat(SelectedData.from_date)}</td>
                </tr>
                <tr>
                  <td className="fadeColor">Rental Duration</td>
                  <td>{SelectedData.no_of_days}</td>
                </tr>
                <tr>
                  <td className="fadeColor">Approved by Rideshare</td>
                  <td
                    className={`${
                      SelectedData.ready_for_rideshare === "yes"
                        ? ""
                        : "text-danger"
                    }`}
                    style={{
                      backgroundColor:
                        SelectedData.ready_for_rideshare === "yes"
                          ? ""
                          : "#f8d7da",
                    }}
                  >
                    {SelectedData.ready_for_rideshare === "yes" ? "Yes" : "No"}
                  </td>
                </tr>

                {SelectedData.ready_for_rideshare === "yes" ? (
                  <>
                    <tr>
                      <td className="fadeColor">Years of hire experience</td>
                      <td>{SelectedData.passenger_for_hire_expe}</td>
                    </tr>
                    <tr>
                      <td className="fadeColor">
                        Approved and ready to work for
                      </td>
                      <td>{cleanInput(SelectedData.work_for)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td className="fadeColor">Using car for</td>
                    <td>{SelectedData.using_car_for}</td>
                  </tr>
                )}

                <tr>
                  <td className="fadeColor">How long need to rent the car</td>
                  <td>{SelectedData.long_need_car}</td>
                </tr>
                {SelectedData.ready_for_rideshare === "yes" && (
                  <tr>
                    <td className="fadeColor">Rideshare Approval Image</td>
                    <td style={{ textAlign: "left" }}>
                      <a
                        href={
                          APL_LINK +
                          "assets/userlicence/" +
                          SelectedData.rideshare_aproval_image
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          style={{ paddingTop: "0.2rem", width: "30px" }}
                          src={pdficon}
                          alt="Licence PDF"
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      </a>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="fadeColor">Driver's License</td>
                  <td style={{ textAlign: "left" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {!isDlEditMode ? (
                        <>
                          <a
                            href={
                              APL_LINK + SelectedData.driving_licence_image_full
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              style={{ paddingTop: "0.2rem", width: "30px" }}
                              src={pdficon}
                              alt="Licence PDF"
                              onError={(e) => (e.target.style.display = "none")}
                            />
                          </a>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => setIsDlEditMode(true)}
                            style={{ fontSize: "12px", padding: "2px 8px" }}
                          >
                            Edit
                          </button>
                        </>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            width: "100%",
                          }}
                        >
                          <input
                            type="file"
                            className="form-control input_field_custom1 trio_name"
                            onChange={(e) => {
                              handleuploadDLFile(e, SelectedData.primary_id);
                              setIsDlEditMode(false);
                            }}
                            style={{ flex: 1 }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setIsDlEditMode(false)}
                            style={{ fontSize: "12px", padding: "2px 8px" }}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">Have you downloaded the MVR</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {SelectedData.mvp_status === "yes" && !isMvrEditMode ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {DamageImg &&
                            DamageImg.length > 0 &&
                            DamageImg.map((img, idx) => (
                              <a
                                href={APL_LINK + damnageImgPath + img.image}
                                key={idx}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  style={{
                                    paddingTop: "0.2rem",
                                    paddingLeft: "0.2rem",
                                    width: "30px",
                                  }}
                                  src={pdficon}
                                  alt="Licence PDF"
                                  onError={(e) =>
                                    (e.target.style.display = "none")
                                  }
                                />
                              </a>
                            ))}
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => setIsMvrEditMode(true)}
                            style={{ fontSize: "12px", padding: "2px 8px" }}
                          >
                            Edit
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="margin_reviewmodel">
                            <div className="col-sm">
                              <div className="img_upd_contr">
                                <div
                                  className="media-placeholder upload_img_contr"
                                  onClick={() => {
                                    if (uploadedDamageImages.length < 4)
                                      document
                                        .getElementById("damageFileInput")
                                        .click();
                                  }}
                                  style={{
                                    opacity:
                                      uploadedDamageImages.length >= 4
                                        ? 0.5
                                        : 1,
                                    pointerEvents:
                                      uploadedDamageImages.length >= 4
                                        ? "none"
                                        : "auto",
                                  }}
                                >
                                  <div className="empty-upload-text">
                                    <i className="bi bi-cloud-upload"></i>
                                    <span>Browse</span>
                                  </div>
                                  <input
                                    type="file"
                                    id="damageFileInput"
                                    accept="image/*"
                                    multiple
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                  />
                                </div>
                              </div>
                            </div>

                            {[...Array(3)].map((_, index) => (
                              <div
                                key={index}
                                className="col-sm"
                                style={{ position: "relative" }}
                              >
                                {uploadedDamageImages[index] &&
                                  uploadedDamageImages[index] !== "0" && (
                                    <div
                                      className="hoverRemoveImg"
                                      onClick={() => handleRemoveImage(index)}
                                    >
                                      <XIcon className="rmv_icn" />
                                    </div>
                                  )}
                                <div className="media-placeholder car-image">
                                  {uploadedDamageImages[index] &&
                                  uploadedDamageImages[index] !== "0" ? (
                                    <img
                                      src={
                                        DringImg +
                                          uploadedDamageImages[index] ||
                                        "/placeholder.svg"
                                      }
                                      alt={`Damage ${index + 1}`}
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="empty-upload-text"
                                      style={{ opacity: 0.5 }}
                                    >
                                      <UploadIcon size={20} color="#aaa" />
                                      <span style={{ marginLeft: "10px" }}>
                                        Empty
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>

                          {isMvrEditMode && (
                            <div className="d-flex w-100 gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setIsMvrEditMode(false)}
                                style={{
                                  fontSize: "12px",
                                  padding: "2px 8px",
                                  marginTop: "5px",
                                  flex: "1",
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  fontSize: "12px",
                                  padding: "2px 8px",
                                  marginTop: "5px",
                                  flex: "1",
                                  border: "1px solid var(--primary-color)",
                                  backgroundColor: "var(--primary-color)",
                                  color: "white",
                                  borderRadius: "5px",
                                }}
                                onClick={() => {
                                  handleuploadDLFileMVR(
                                    SelectedData,
                                    SelectedData.primary_id,
                                  );
                                  setIsMvrEditMode(false);
                                  handleClose();
                                }}
                              >
                                Save
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Rejection Reason Input */}
        <div
          className="releaseModalHeadLeft"
          style={{ display: "flex", alignItems: "center", gap: "1rem" }}
        >
          <form id="accept_reject_data">
            <div
              style={{
                display: activeAgree === false ? "flex" : "none",
                justifyContent: "space-around",
                marginBottom: "0",
              }}
            >
              <input
                type="text"
                id="reason_for_cancel"
                name="reason_for_cancel"
                placeholder="Reason for cancel"
                minLength={3}
                maxLength={75}
                className={`trio_name form-control input_field_custom1 ${
                  !activeAgree ? "trio_mandatory" : ""
                }`}
                style={{ paddingLeft: "20px" }}
              />
            </div>
          </form>
        </div>

        {/* Download Documents Section */}
        <div className="buttnsActionsForm">
          <p>Download Documents</p>
          <div className="downLoddBttns">
            <button
              type="button"
              onClick={() => triggerDownloadPDF(SelectedData)}
            >
              Application
            </button>
            <button
              type="button"
              onClick={() => triggerDownloadMVR(SelectedData, DamageImg)}
            >
              MVR
            </button>
            <button
              type="button"
              onClick={() =>
                triggerDownloadDL(
                  SelectedData,
                  SelectedData.driving_licence_image_full,
                )
              }
            >
              Driving Licence
            </button>
          </div>
        </div>

        {/* Status Message */}
        <div className="releaseModalHeadLeft align-items-start mt-5">
          <img
            style={{ paddingTop: "0.2rem" }}
            src={DoneGreen}
            alt="Rapid Car Leasing"
          />
          <h5>
            <span>&nbsp;{SelectedData.show_msg}</span>
          </h5>
        </div>
      </Modal.Body>

      {/* Modal Footer Buttons */}
      <Modal.Footer className="releaseModalFooter row">
        <Button
          style={{
            display: activeAgree ? "" : "none",
            backgroundColor: "green",
            borderColor: "green",
            opacity: SelectedData.mvp_status === "yes" ? "1" : "0.5",
            pointerEvents: SelectedData.mvp_status === "yes" ? "auto" : "none",
          }}
          className={`releaseModalBtn ${SelectedData.button_class} col-sm-6`}
          onClick={() => {
            setActiveAgree(true);
            handleActiveDeactive(true);
          }}
        >
          {SelectedData.button_name}
        </Button>

        <Button
          style={{
            display: !activeAgree ? "" : "none",
          }}
          className={`releaseModalBtn ${SelectedData.button_class} col-sm-6`}
          onClick={() => handleActiveDeactive(false)}
        >
          {SelectedData.button_name_next}
        </Button>

        <Button
          style={{ display: activeAgree ? "" : "none" }}
          className={`releaseModalBtn ${SelectedData.button_class} col-sm-6`}
          onClick={() => toggleActiveAgree(false)}
        >
          {SelectedData.button_name_next}
        </Button>

        <Button
          className="editNowBtn Edit_Now col-sm-6"
          onClick={() => handleClose(1)}
        >
          <label style={{ cursor: "pointer" }}>Close</label>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReviewModal;
